import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M2.5 6C2.5 5.72386 2.72386 5.5 3 5.5H9C9.27614 5.5 9.5 5.72386 9.5 6C9.5 6.27614 9.27614 6.5 9 6.5H3C2.72386 6.5 2.5 6.27614 2.5 6Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M1 3C1 2.72386 1.22386 2.5 1.5 2.5H10.5C10.7761 2.5 11 2.72386 11 3C11 3.27614 10.7761 3.5 10.5 3.5H1.5C1.22386 3.5 1 3.27614 1 3Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M4 9C4 8.72386 4.22386 8.5 4.5 8.5H7.5C7.77614 8.5 8 8.72386 8 9C8 9.27614 7.77614 9.5 7.5 9.5H4.5C4.22386 9.5 4 9.27614 4 9Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.33337 7.99967C3.33337 7.63148 3.63185 7.33301 4.00004 7.33301H12C12.3682 7.33301 12.6667 7.63148 12.6667 7.99967C12.6667 8.36786 12.3682 8.66634 12 8.66634H4.00004C3.63185 8.66634 3.33337 8.36786 3.33337 7.99967Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M1.33337 3.99967C1.33337 3.63148 1.63185 3.33301 2.00004 3.33301H14C14.3682 3.33301 14.6667 3.63148 14.6667 3.99967C14.6667 4.36786 14.3682 4.66634 14 4.66634H2.00004C1.63185 4.66634 1.33337 4.36786 1.33337 3.99967Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M5.33337 11.9997C5.33337 11.6315 5.63185 11.333 6.00004 11.333H10C10.3682 11.333 10.6667 11.6315 10.6667 11.9997C10.6667 12.3679 10.3682 12.6663 10 12.6663H6.00004C5.63185 12.6663 5.33337 12.3679 5.33337 11.9997Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.16663 10.0003C4.16663 9.54009 4.53972 9.16699 4.99996 9.16699H15C15.4602 9.16699 15.8333 9.54009 15.8333 10.0003C15.8333 10.4606 15.4602 10.8337 15 10.8337H4.99996C4.53972 10.8337 4.16663 10.4606 4.16663 10.0003Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M1.66663 5.00033C1.66663 4.54009 2.03972 4.16699 2.49996 4.16699H17.5C17.9602 4.16699 18.3333 4.54009 18.3333 5.00033C18.3333 5.46056 17.9602 5.83366 17.5 5.83366H2.49996C2.03972 5.83366 1.66663 5.46056 1.66663 5.00033Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M6.66663 15.0003C6.66663 14.5401 7.03972 14.167 7.49996 14.167H12.5C12.9602 14.167 13.3333 14.5401 13.3333 15.0003C13.3333 15.4606 12.9602 15.8337 12.5 15.8337H7.49996C7.03972 15.8337 6.66663 15.4606 6.66663 15.0003Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 8.5C7.77614 8.5 8 8.72386 8 9C8 9.27614 7.77614 9.5 7.5 9.5H4.5C4.22386 9.5 4 9.27614 4 9C4 8.72386 4.22386 8.5 4.5 8.5H7.5ZM9 5.5C9.27614 5.5 9.5 5.72386 9.5 6C9.5 6.27614 9.27614 6.5 9 6.5H3C2.72386 6.5 2.5 6.27614 2.5 6C2.5 5.72386 2.72386 5.5 3 5.5H9ZM10.5 2.5C10.7761 2.5 11 2.72386 11 3C11 3.27614 10.7761 3.5 10.5 3.5H1.5C1.22386 3.5 1 3.27614 1 3C1 2.72386 1.22386 2.5 1.5 2.5H10.5Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 11.333C10.3682 11.333 10.6667 11.6315 10.6667 11.9997C10.6667 12.3679 10.3682 12.6663 10 12.6663H6.00004C5.63185 12.6663 5.33337 12.3679 5.33337 11.9997C5.33337 11.6315 5.63185 11.333 6.00004 11.333H10ZM12 7.33301C12.3682 7.33301 12.6667 7.63148 12.6667 7.99967C12.6667 8.36786 12.3682 8.66634 12 8.66634H4.00004C3.63185 8.66634 3.33337 8.36786 3.33337 7.99967C3.33337 7.63148 3.63185 7.33301 4.00004 7.33301H12ZM14 3.33301C14.3682 3.33301 14.6667 3.63148 14.6667 3.99967C14.6667 4.36786 14.3682 4.66634 14 4.66634H2.00004C1.63185 4.66634 1.33337 4.36786 1.33337 3.99967C1.33337 3.63148 1.63185 3.33301 2.00004 3.33301H14Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5 14.167C12.9602 14.167 13.3333 14.5401 13.3333 15.0003C13.3333 15.4606 12.9602 15.8337 12.5 15.8337H7.49996C7.03972 15.8337 6.66663 15.4606 6.66663 15.0003C6.66663 14.5401 7.03972 14.167 7.49996 14.167H12.5ZM15 9.16699C15.4602 9.16699 15.8333 9.54009 15.8333 10.0003C15.8333 10.4606 15.4602 10.8337 15 10.8337H4.99996C4.53972 10.8337 4.16663 10.4606 4.16663 10.0003C4.16663 9.54009 4.53972 9.16699 4.99996 9.16699H15ZM17.5 4.16699C17.9602 4.16699 18.3333 4.54009 18.3333 5.00033C18.3333 5.46056 17.9602 5.83366 17.5 5.83366H2.49996C2.03972 5.83366 1.66663 5.46056 1.66663 5.00033C1.66663 4.54009 2.03972 4.16699 2.49996 4.16699H17.5Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconFilterLines: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"filter-lines"} {...props} />
);
